import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/modules/auth/presentation/store/auth.store';
import { authContainer } from '@/modules/auth/di/container';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, setAuth } = useAuthStore();

  if (!isAuthenticated) {
    const stored = authContainer.repository.getStoredAuth();
    if (stored) {
      setAuth(stored);
      return <>{children}</>;
    }
    return <Navigate to="/sign-in" replace />;
  }

  return <>{children}</>;
}
